import React from "react";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import ilustration from "../img/illustrationTwoGirls.png";

const IndividualsNeedsSection = ({ width }) => {
  return (
    <MDBRow className="bg-blue-img banner-padding needs-section-bottom-padding-mobile" id="needs-banner">
      <MDBCol sm="12" md="12" lg="6" className="">
        <div className="d-flex justify-content-center align-items-center h-100">
          <div className="text-illustration">
            <h1 className={width > 830 ? "text-al text-start fs-48-32" : "text-al text-center fs-48-32"}>
              Let’s Talk about Your Needs
            </h1>
            <p className="text-dm">
              For far too long we’ve accepted women's healthcare that doesn’t
              address our needs, especially when it comes to pelvic care.
            </p>
            <p className="text-dm">
              Elana’s personalized approach is designed to transform your
              standard of care and show you options that bring relief,
              happiness, and confidence.{" "}
            </p>
            <p className="text-dm">
              We are working to gather a team of pelvic care specialists,
              education, and products for a variety of pelvic health issues that
              can help you on your healing journey.{" "}
            </p>
          </div>
        </div>
      </MDBCol>
      <MDBCol sm="12" md="12" lg="6" className="">
        <div className="d-flex justify-content-center align-items-center h-100">
          <img
            src={ilustration}
            className="img-fluid ima img-illustration-padding w-100"
          />
        </div>
      </MDBCol>
    </MDBRow>
  );
};

export default IndividualsNeedsSection;

// text-individual-home-two padding-fix
// text-individual-home-two padding-fix
// text-individual-home-two padding-fix
